<template>
  <el-dialog
    v-model="visibleLocal"
    :before-close="handleClose"
    fullscreen
    width="50%"
    draggable
  >
    <template #title>
      <span v-if="isAddMode">中古パーツ 追加</span>
      <span v-else-if="isEditMode">中古パーツ 修正</span>
      <span v-else>中古パーツ 詳細</span>
    </template>

    <el-row justify="center">
      <el-col :span="12">
        <el-form ref="formRef" :model="formModel" label-width="120px">
          <!-- 管理番号（自动生成且不可编辑） -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="管理番号">
                <el-input
                  style="width: 200px"
                  v-model="formModel.management_number"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 售出状态 -->
              <el-form-item label="販売状況">
                <el-radio-group
                  v-model="formModel.sold_out_flg"
                  :disabled="isViewMode"
                >
                  <el-radio value="0">販売中</el-radio>
                  <el-radio value="1">売却済</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 画像 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="マイン画像">
                <el-upload
                  class="upload-demo"
                  action="#"
                  :http-request="handleFileChange"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  list-type="picture-card"
                >
                  <img
                    v-if="formModel.img"
                    :src="formModel.img"
                    class="uploaded-image"
                  />
                  <el-icon v-else class="upload-icon"><Plus /></el-icon>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- sub画像 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="サブ画像"></el-form-item
            ></el-col>
          </el-row>
          <el-row style="padding-bottom: 20px">
            <el-col :span="24" style="margin-left: 120px">
              <el-upload
                action="#"
                :http-request="handleFileChange2"
                :before-upload="beforeUpload"
                list-type="picture-card"
                :file-list="subFileList"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemoveFile"
                multiple
              >
                <el-icon><Plus /></el-icon>
              </el-upload>
            </el-col>
          </el-row>

          <!-- メーカー 和 車種（联动选择） -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="メーカー">
                <el-select
                  v-model="formModel.manufacturer"
                  :disabled="isViewMode"
                  @change="fetchCarTypes"
                  style="width: 220px"
                >
                  <el-option
                    v-for="item in manufacturers"
                    :key="item.code"
                    :label="item.name_ja"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="車種">
                <el-select
                  v-model="formModel.type"
                  :disabled="isViewMode"
                  style="width: 220px"
                >
                  <el-option
                    v-for="item in carTypes"
                    :key="item.code"
                    :label="item.name_ja"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 名称 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称（日）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.name_ja"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="名称（英）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.name_en"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 年式 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="年式（日）">
                <el-date-picker
                  v-model="formModel.year_ja"
                  type="month"
                  format="YYYY/MM"
                  value-format="YYYYMM"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="年式（英）">
                <el-date-picker
                  v-model="formModel.year_en"
                  type="month"
                  format="YYYY/MM"
                  value-format="YYYYMM"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 掲載日 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="掲載日（日）">
                <el-date-picker
                  v-model="formModel.publish_date_ja"
                  type="date"
                  format="YYYY/MM/DD"
                  value-format="YYYYMMDD"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="掲載日（英）">
                <el-date-picker
                  v-model="formModel.publish_date_en"
                  type="date"
                  format="YYYY/MM/DD"
                  value-format="YYYYMMDD"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 価格 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="価格（日）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.price_ja"
                  :disabled="isViewMode"
                >
                  <template #append>円</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="価格（英）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.price_en"
                  :disabled="isViewMode"
                >
                  <template #append>USD</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 評価点 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="評価点（日）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.evaluation_ja"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="評価点（英）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.evaluation_en"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- グレード -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="グレード（日）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.grade_ja"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="グレード（英）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.grade_en"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 型式 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="型式（日）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.model_ja"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="型式（英）">
                <el-input
                  style="width: 200px"
                  v-model="formModel.model_en"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 特徴 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="特記（日）">
                <el-input
                  style="width: 400px"
                  v-model="formattedPointsJa"
                  type="textarea"
                  :rows="8"
                  :disabled="isViewMode"
                  class="multiline-text"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="特記（英）">
                <el-input
                  style="width: 400px"
                  v-model="formattedPointsEn"
                  type="textarea"
                  :rows="8"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 保証 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="保証（日）">
                <el-input
                  style="width: 400px"
                  v-model="formModel.warranty_ja"
                  type="textarea"
                  :rows="3"
                  :disabled="isViewMode"
                  class="multiline-text"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保証（英）">
                <el-input
                  style="width: 400px"
                  v-model="formModel.warranty_en"
                  type="textarea"
                  :rows="3"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 整備 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="整備（日）">
                <el-input
                  style="width: 400px"
                  v-model="formModel.maintenance_ja"
                  type="textarea"
                  :rows="3"
                  :disabled="isViewMode"
                  class="multiline-text"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="整備（英）">
                <el-input
                  style="width: 400px"
                  v-model="formModel.maintenance_en"
                  type="textarea"
                  :rows="3"
                  :disabled="isViewMode"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <template #footer>
      <el-button @click="handleClose">キャンセル</el-button>
      <el-button
        type="primary"
        v-if="isEditMode || isAddMode"
        @click="handleSave"
        >保存</el-button
      >
    </template>
  </el-dialog>
  <el-dialog v-model="dialogVisible" title="" width="500">
    <img width="100%" :src="dialogImageUrl" alt="Preview Image" />
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          確定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { ElMessage, ElLoading } from "element-plus";
import { supabase } from "@/supabase.js";

export default {
  props: {
    visible: Boolean,
    mode: String,
    carInfo: Object,
  },
  emits: ["update:visible", "refreshList"],

  setup(props, { emit }) {
    // const emit = defineEmits(["refreshList","refreshList"]); // 定义 emit 事件
    const visibleLocal = ref(props.visible);
    const formModel = ref({});
    const manufacturers = ref([]);
    const carTypes = ref([]);
    const mode = ref(props.mode);
    const isAddMode = ref(false);
    const isEditMode = ref(false);
    const isViewMode = ref(false);
    let selectedFile = null;
    const subFileList = ref([]);
    const toBeDeletedFiles = ref([]); // 待删除的图片列表
    const dialogVisible = ref(false);
    const dialogImageUrl = ref("");
    const oldImgUrl = ref("");

    const fetchSubFileList = async () => {
      const { data } = await supabase
        .from("img_info")
        .select("sub_imgurl ,id")
        .eq("kbn", "1")
        .eq("sub_id", formModel.value.management_number);
      subFileList.value = (data || []).map((item, index) => ({
        name: `image_${index + 1}`, // 生成文件名
        url: item.sub_imgurl, // 绑定URL
        isExisting: true, // 识别是否来自数据库
        id: item.id,
      }));
    };

    const fetchManufacturers = async () => {
      const { data } = await supabase
        .from("manufacturer_m")
        .select("code, name_ja");
      manufacturers.value = data || [];
    };

    const fetchCarTypes = async () => {
      if (!formModel.value.manufacturer) return;
      const { data } = await supabase
        .from("model_m")
        .select("code, name_ja")
        .eq("m_code", formModel.value.manufacturer);
      carTypes.value = data || [];
    };

    const handleClose = () => {
      // 清除图片预览（仅当未保存时）
      if (!formModel.value.img.startsWith("http")) {
        formModel.value.img = "";
      }
      subFileList.value = [];
      emit("update:visible", false);
    };

    const handleSave = async () => {
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 先上传图片，获取 URL
      formModel.value.img = await uploadImage();

      await saveSubImg();

      let query = isAddMode.value
        ? supabase.from("part_info").insert([formModel.value])
        : supabase
            .from("part_info")
            .update(formModel.value)
            .eq("management_number", formModel.value.management_number);
      const { error } = await query;
      error ? ElMessage.error("保存失敗") : ElMessage.success("保存成功"),
        handleClose();
      emit("refreshList");
      loading.close();
    };

    const saveSubImg = async () => {
      // **删除用户标记删除的文件**
      for (const file of toBeDeletedFiles.value) {
        const filePathdel = file.url.replace(
          "https://lygnfnlswhklapuygsox.supabase.co/storage/v1/object/public/img/",
          ""
        );
        // 删除 Supabase 存储桶文件
        await supabase.storage.from("img").remove([filePathdel]);
        // 删除数据库记录
        await supabase.from("img_info").delete().eq("id", file.id);
      }

      // **上传新文件**
      for (const file of subFileList.value) {
        if (!file.isExisting) {
          const fileExt = file.rawFile.name.split(".").pop(); // 获取文件扩展名
          const fileName = `${file.rawFile.uid}.${fileExt}`; // 生成唯一文件名
          const filePath = `part_info/${formModel.value.management_number}/${fileName}`;

          const { data } = await supabase.storage
            .from("img")
            .upload(filePath, file.rawFile);

          console.log(
            "path:" +
              supabase.storage.from("img").getPublicUrl(filePath).data.publicUrl
          );

          if (data) {
            // **存储数据库**
            const { error } = await supabase.from("img_info").insert({
              kbn: "1",
              sub_id: formModel.value.management_number,
              sub_imgurl: supabase.storage.from("img").getPublicUrl(filePath)
                .data.publicUrl,
            });

            if (error) {
              console.error("Insert Error:", error);
            }
          }
        }
      }

      // 3️ **清空删除列表**
      toBeDeletedFiles.value = [];
    };

    const generateManagementNumber = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    };

    const formattedPointsJa = computed({
      get: () => formModel.value.points_ja.replace(/\\n/g, "\n"), // 显示时转换
      set: (val) => (formModel.value.points_ja = val.replace(/\n/g, "\\n")), // 输入时转换
    });
    const formattedPointsEn = computed({
      get: () => formModel.value.points_en.replace(/\\n/g, "\n"),
      set: (val) => (formModel.value.points_en = val.replace(/\n/g, "\\n")),
    });

    const beforeUpload = (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        ElMessage.error("JPG/PNG 形式のみ対応しています。");
        return false;
      }
      return true;
    };

    // 选择文件时，更新预览
    const handleFileChange = (file) => {
      selectedFile = file.file;
      const reader = new FileReader();
      reader.onload = (e) => {
        formModel.value.img = e.target.result;
      };
      reader.readAsDataURL(selectedFile);
    };

    // 选择文件时，更新预览
    const handleFileChange2 = (file) => {
      // 生成预览图
      const reader = new FileReader();
      reader.onload = (e) => {
        subFileList.value.push({
          name: file.file.name,
          url: e.target.result, // 预览 URL
          isExisting: false, // 标记为新上传
          rawFile: file.file, // 存储原始文件，待上传
        });
      };
      reader.readAsDataURL(file.file);
    };

    // 📌 上传图片到 Supabase Storage 并返回 URL
    const uploadImage = async () => {
      if (!selectedFile) return formModel.value.img; // 如果未选择新图片，保留原 URL

      // const filePath = `home_info/${selectedFile.name}`;
      const fileExt = selectedFile.name.split(".").pop(); // 获取文件扩展名
      const fileName = `${selectedFile.uid}.${fileExt}`; // 生成唯一文件名
      const filePath = `part_info/${formModel.value.management_number}/${fileName}`;

      // 先删除旧文件（如果有）
      if (formModel.value.img && oldImgUrl.value !== formModel.value.img) {
        // const oldFileName = formModel.value.img.split("/").pop();
        const filePathdel = oldImgUrl.value.replace(
          "https://lygnfnlswhklapuygsox.supabase.co/storage/v1/object/public/img/",
          ""
        );
        await supabase.storage.from("img").remove([filePathdel]);
      }

      // 上传新文件
      const { error } = await supabase.storage
        .from("img")
        .upload(filePath, selectedFile);

      if (error) {
        console.error("画像アップロード失敗:", error);
        ElMessage.error("画像アップロード失敗しました。");
        return formModel.value.img;
      }

      // 获取上传后的 URL
      return supabase.storage.from("img").getPublicUrl(filePath).data.publicUrl;
    };

    const handlePictureCardPreview = (uploadFile) => {
      console.log("uploadFile:" + uploadFile.url);
      dialogImageUrl.value = uploadFile.url;
      dialogVisible.value = true;
    };

    // **点击删除时，只是标记，不立即删除**
    const handleRemoveFile = (file) => {
      if (file.isExisting) {
        // 如果是数据库已有的图片，添加到删除列表
        toBeDeletedFiles.value.push({
          url: file.url,
          id: file.id,
        });
      }
      // 过滤 subFileList，删除该文件
      subFileList.value = subFileList.value.filter(
        (item) => item.url !== file.url
      );
    };
    onMounted(fetchManufacturers);

    // onMounted(async () => {
    //   await fetchManufacturers();
    //   await fetchSubFileList();
    // });
    watch(
      () => props.carInfo,
      async (newVal) => {
        formModel.value =
          props.mode === "add"
            ? {
                management_number: generateManagementNumber(),
                img: "", // 图片链接

                // 价格
                price_ja: "", // 価格（日文）
                price_en: "", // 価格（英文）

                // 车辆信息
                manufacturer: "", // メーカー
                type: "", // 車種（日文）
                year_ja: "", // 年式（日文）
                year_en: "", // 年式（英文）
                evaluation_ja: "", // 評価点（日文）
                evaluation_en: "", // 評価点（英文）
                grade_ja: "", // グレード（日文）
                grade_en: "", // グレード（英文）
                model_ja: "", // 型式（日文）
                model_en: "", // 型式（英文）
                // 掲載日（发布日期）
                publish_date_ja: "", // 掲載日（日文）
                publish_date_en: "", // 掲載日（英文）

                // 售出状态
                sold_out_flg: "0", // 1: 售出, 0: 在售
                // 保証
                warranty_ja: "",
                warranty_en: "",
                // 整備
                maintenance_ja: "",
                maintenance_en: "",
                points_ja: "",
                points_en: "",
                name_ja: "",
                name_en: "",
              }
            : {
                ...newVal,
                img: newVal.img,
                management_number: newVal.management_number,
                manufacturer: newVal.manufacturer
                  ? Number(newVal.manufacturer)
                  : null,
                type: newVal.type ? Number(newVal.type) : null,
              };
        // if (mode.value !== "add") {
        //   await fetchSubFileList();
        //   await fetchManufacturers(); // 获取メーカー列表
        //   if (formModel.value.manufacturer) {
        //     await fetchCarTypes(); // 根据メーカー获取车种
        //   }
        //   //   await fetchSubFileList();
        // }
        if (props.mode !== "add") {
          await fetchSubFileList();
        }
      },
      { deep: true, immediate: true }
    );

    watch(
      () => props.visible,
      async (newVal) => {
        visibleLocal.value = newVal;
        if (newVal) {
          oldImgUrl.value = "";
          // await fetchSubFileList();
          await fetchManufacturers(); // 获取メーカー列表
          if (formModel.value.manufacturer) {
            await fetchCarTypes(); // 根据メーカー获取车种
          }
          oldImgUrl.value = formModel.value.img;
        }
      }
    );

    watch(
      () => props.mode,
      async (newVal) => {
        mode.value = newVal;
        if (mode.value === "add") {
          isAddMode.value = true;
          isViewMode.value = false;
          isEditMode.value = false;
        } else if (mode.value === "edit") {
          isAddMode.value = false;
          isViewMode.value = false;
          isEditMode.value = true;
          (formModel.value.management_number = props.carInfo.management_number),
            // console.log("props.carInfo:",props.carInfo.management_number)
            await fetchSubFileList();
        } else {
          isAddMode.value = false;
          isViewMode.value = true;
          isEditMode.value = false;
          (formModel.value.management_number = props.carInfo.management_number),
            // console.log("props.carInfo:",props.carInfo.management_number)
            await fetchSubFileList();
        }
      }
    );

    return {
      visibleLocal,
      formModel,
      manufacturers,
      carTypes,
      fetchCarTypes,
      handleClose,
      handleSave,
      isAddMode,
      isViewMode,
      isEditMode,
      formattedPointsJa,
      formattedPointsEn,
      beforeUpload,
      handleFileChange,
      subFileList,
      dialogVisible,
      dialogImageUrl,
      handlePictureCardPreview,
      handleRemoveFile,
      handleFileChange2,
    };
  },
};
</script>
<style scoped>
.multiline-text {
  white-space: pre-wrap;
}
.uploaded-image {
  height: 150px; /* 只控制高度 */
  width: auto; /* 宽度自适应 */
  object-fit: contain; /* 保持原比例，不裁剪 */
  border-radius: 8px; /* 圆角 */
  display: block;
  max-width: 100%; /* 防止超出父容器 */
}
:deep(.el-upload--picture-card) {
  --el-upload-picture-card-size: 148px;
  align-items: center;
  background-color: var(--el-fill-color-lighter);
  border: 1px dashed var(--el-border-color-darker);
  border-radius: 0px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  height: var(--el-upload-picture-card-size);
  justify-content: center;
  vertical-align: top;
  width: 150px;
}
</style>
